import { ChartConfigurationOption } from '../../../models';

export class ChartDirectiveConfiguration {
    data: any[];
    series: any[];
    options: ChartConfigurationOption;

    constructor() {
        this.series = [];
        this.data = [];
        this.options = new ChartConfigurationOption();
    }
}